export var containerBaseStyle = 'relative flex flex-col justify-center items-center block w-full border-2 border-dashed rounded-lg text-center focus:outline-none focus:ring-2 hover:border-uiLight';
export var containerStyle = 'border-uiLight';
export var fileContainerStyle = 'border-successMain';
export var errorContainerStyle = 'border-errorMain';
export var iconBaseStyle = 'h-12 w-12 rounded-full flex justify-center items-center';
export var iconStyle = 'text-white h-6 w-6 rounded-full';
export var fileIconStyle = 'text-successMain';
export var errorIconStyle = 'text-errorMain';
export var buttonlabelStyle = 'mt-2 block break-all';
export var labelStyle = 'mb-1 block';
export var imageContainer = 'w-full bg-center bg-contain bg-no-repeat p-9 flex flex-col flex-1 justify-center items-center';
//# sourceMappingURL=image-input.styles.js.map